import type { MouseEvent } from 'react';

import { useSignMessage } from 'wagmi';

import { fetchTurtleClubSiweMessage } from '@api';

import { ExternalLink } from '@uikit/components/ExternalLink';
import { AngleRight } from '@uikit/icons/AngleRight';

import { useAuth } from '@shared/common/providers/AuthProvider';
import useCheckRequiredSelfData from '@shared/hooks/useCheckRequiredSelfData';
import useMagicIdUserWalletInfo from '@shared/hooks/useMagicIdUserWalletInfo';

import { useTurtleClubMembership, useVerifyTurtleClubSiwe } from '@query/turtle-club';

import { cn } from '@ui/uikit/utils';

export const JoinTurtleClubActionButton = () => {
  const { check } = useCheckRequiredSelfData();

  const { isAuth } = useAuth();

  const { data: turtleClubMembership } = useTurtleClubMembership({ isAuth });

  const { getUserWalletAddress } = useMagicIdUserWalletInfo();

  const { signMessageAsync } = useSignMessage();

  const { mutateAsync: verifyTurtleClubSiwe } = useVerifyTurtleClubSiwe();

  const handleClick = async (event: MouseEvent<HTMLElement>) => {
    if (!check({ auth: true })) {
      event.preventDefault();

      return;
    }

    const { address } = getUserWalletAddress();

    const { signMessage, signupToken } = await fetchTurtleClubSiweMessage({
      address,
    });

    const signature = await signMessageAsync({
      message: signMessage,
    });

    await verifyTurtleClubSiwe({
      address,
      signature,
      signupToken,
    });
  };

  return (
    <ExternalLink
      onClick={handleClick}
      className={cn(
        'button button-solid-secondary button-md md:button-xl md:min-h-12 rounded-xl gap-2',
        {
          ['button-solid  button-color-green cursor-default pointer-events-none']:
            turtleClubMembership?.joined,
        },
      )}
    >
      {turtleClubMembership?.joined ? (
        'You have successfully signed up!'
      ) : (
        <>
          {'Join Turtle Club '} <AngleRight className="icon-lg" />
        </>
      )}
    </ExternalLink>
  );
};
